import { ArchiveItem } from "@/features/archive/components/lists/ArchiveItem";
import type { ArchiveThread } from "@/features/archive/types";
import { MobileCatalogGridLayout } from "@/features/catalog/components/lists/MobileCatalogGridLayout";
import { ComponentScope } from "@/shared/ui/component-hierarchy/ComponentScope";
import { useComponentNode } from "@/shared/ui/component-hierarchy/hooks";
import { Message } from "@/shared/ui/feedback";

type ArchiveGridProps = {
  readonly threads: ArchiveThread[];
  readonly columns: number;
  readonly emptyMessage?: string;
};

export const ArchiveGrid: React.FunctionComponent<ArchiveGridProps> = ({
  ...viewProps
}: ArchiveGridProps) => {
  const node = useComponentNode();

  return (
    <ComponentScope node={node}>
      <ArchiveGridView {...viewProps} />
    </ComponentScope>
  );
};

/** 過去ログ一覧をpropsだけから描画するモバイルView。 */
export const ArchiveGridView: React.FunctionComponent<ArchiveGridProps> = ({
  threads,
  columns,
  emptyMessage = "過去ログはまだありません",
}: ArchiveGridProps) => {
  if (threads.length === 0) {
    return <Message variant="info">{emptyMessage}</Message>;
  }

  return (
    <MobileCatalogGridLayout columns={columns}>
      {threads.map((thread) => (
        <ArchiveItem key={thread.threadId} thread={thread} />
      ))}
    </MobileCatalogGridLayout>
  );
};
